const data = [
    {
        name: 'JAVA',
        intro: 'Introduction to Programming in JAVA',
        linkback: './java.jpg',
        link: 'https://github.com/nhattanho/CMPR112-Java'
    }
]

export default data;